'use client';

import { useState } from 'react';
import { TextLink, Drawer, Heading, TextPassage } from '@petsmart-ui/sparky';
import { parseRichText } from '@libs/contentful';
import { useProductDetails } from '@app/pdp/hooks/useProductDetails';

export default function LivePetDrawer() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { product } = useProductDetails();
    const { productLivePetPolicy } = product;

    const livePetPolicyNode = productLivePetPolicy.livePetPolicyContent
        ? parseRichText(productLivePetPolicy.livePetPolicyContent)
        : null;

    return (
        <>
            <TextLink onClick={() => setDrawerOpen(true)}>Details</TextLink>
            <Drawer
                align="right"
                onClose={() => setDrawerOpen(false)}
                isActive={drawerOpen}
            >
                <Drawer.Header>
                    <Heading size="headline" tagName="h2">
                        {productLivePetPolicy.livePetPolicyTitle}
                    </Heading>
                </Drawer.Header>
                <Drawer.Body>
                    <TextPassage>{livePetPolicyNode}</TextPassage>
                </Drawer.Body>
            </Drawer>
        </>
    );
}
